import apiClient from 'clients/apiClient';
import config from 'helpers/config';

const baseURL = config.getApiBaseUrl();

export const bookingRefundRequest = (id, payload = {}) => {
    return apiClient.create(`${ baseURL }/bookings/${ id }/refund`, payload);
};



// WEBPACK FOOTER //
// ./src/http/requests/bookings/refundBookingRequests.js